
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProgressBar extends Vue {
  //#region [ CONSTANTS ]
  readonly HEIGHT = '20px' as const;
  //#endregion



  //#region [ PROPS ]
  @Prop({ default: '#FFF' })
  readonly color!: string;

  @Prop({ default: 'none' })
  readonly backgroundColor!: string;

  @Prop({ default: null })
  readonly height?: string;
  //#endregion



  //#region [ DATA ]
  startTime: number | null = null;
  duration: number | null = null;
  progress: number = 0;
  animationFrameId: number | null = null;
  //#endregion



  //#region [ LIFECYCLE ]
  beforeDestroy() {
    this.clearTimeoutCalculateProgress();
  }
  //#endregion

  //#region [ METHODS ]
  start(duration: number): void {
    this.progress = 0;
    this.duration = duration;
    this.startTime = Date.now();
    this.startTimeoutCalculateProgress();
  }

  startTimeoutCalculateProgress(): void {
    this.clearTimeoutCalculateProgress();

    const animate = () => {
      this.progress = this.calculateProgress();

      if (this.progress < 100) {
        this.animationFrameId = requestAnimationFrame(animate);
      } else {
        this.clearTimeoutCalculateProgress();
      }
    };

    this.animationFrameId = requestAnimationFrame(animate);
  }

  clearTimeoutCalculateProgress(): void {
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
      this.animationFrameId = null;
    }
  }

  calculateProgress(): number {
    if (!this.startTime || !this.duration) {
      return 0;
    }
    const elapsed = Date.now() - this.startTime;
    return Math.min((elapsed / this.duration) * 100, 100);
  }
  //#endregion
}
